import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HotelBookingDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                      <Link to="/TravelInsurance"> Travel Insurance</Link>
                    </li>
                    <li>
                      <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                    </li>
                     <li>
                      <Link to="/MICE"> MICE</Link>
                     </li>
                    <li>
                      <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                    </li>
                    <li>
                      <Link to="/HotelBooking"> Hotel Booking </Link>
                    </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner7.jpg" alt="img" />
                  </div>
                  <div className="details">
                    <h4>
                    Best Hotel Deals - From Budget to Luxury
                    </h4>
                    <p>
                    We offer hotel booking services across India and globally. Whether you’re looking for a family-friendly stay, business hotel,
                     or romantic resort — we find the perfect place at the best price.
                    </p>
                   
                  
                    <h4>Highlights:</h4>
                  
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle />Verified Hotel Options
                          </li>
                          <li>
                            <FaCheckCircle /> Best Rates Guaranteed
                          </li>
                          <li>
                            <FaCheckCircle /> Instant Booking Confirmation
                          </li>
                          <li>
                            <FaCheckCircle /> Corporate & Group Rates
                          </li>
                         
                        </ul>
                      </div>
                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Relax, we've got your stay sorted
                    </Link>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default HotelBookingDetails;

